import httpService from "../../services/http.service";
import Config from "../../config.json"
import axios from "axios";
class ShiftService{
    GetShiftConfiguration(fromDate,toDate,emailid) {
        return new Promise((resolve, reject) => {
            let config = {
                Type: 'Get',
                method: 'GET',
                url: "https://people.zoho.com/people/api/attendance/getShiftConfiguration?emailId="+emailid+"&sdate="+fromDate+"&edate="+toDate,
                headers: { "Authorization": localStorage.getItem('token') },
                data: {}
            }
            axios.post(Config.backend_aws_server_url+'zoho/workdrive', config)
                .then((result) => {
                    resolve(result);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    }

    MapShiftToUser(fromDate,toDate,empId,ShiftName) {
        return new Promise((resolve, reject) => {
            let config = {
                Type: 'Create',
                method: 'POST',
                url: "https://people.zoho.com/people/api/attendance/updateUserShift?empId="+empId+"&shiftName="+ShiftName+"&fdate="+fromDate+"&tdate="+toDate,
                headers: { "Authorization": localStorage.getItem('token') },
                data: {}
            }
            axios.post(Config.backend_aws_server_url+'zoho/workdrive', config)
                .then((result) => {
                    resolve(result);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    }
}

export default new ShiftService();